import ToUsersEnum from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/NotificationService/Enums/ToUsersEnum";
import DocumentTypeEnum from "@/api/dataSource/api/Spirit/Entities/Enums/DocumentTypeEnum";
import NotificationEnum from "@/api/dataSource/api/Spirit/Entities/Enums/NotificationEnum";
import NotificationTypeEnum from "@/api/dataSource/api/Spirit/Entities/Enums/NotificationTypeEnum";
import Vue from "vue";
 
Vue.filter('NotificationEnum', function(value: NotificationEnum): string {  
    if (value == null) {
      return '';
    }
    switch(value) {
      case NotificationEnum.PremiumAccessThreeDaysLeft:
        return 'Осталось 3 дня до окончания премиум доста';
      case NotificationEnum.ThreeDaysInactive:
        return '3 дня неактивности';
        case NotificationEnum.TwentyDaysInactive:
          return '20 дней неактивности';
      case NotificationEnum.Welcome:
        return 'Приветствие';
      case NotificationEnum.PasswordChange:
        return 'Смена пароля';
    }
    return '';
});

Vue.filter('NotificationTypeEnum', function(value: NotificationTypeEnum): string {  
    if (value == null) {
      return '';
    }
    switch(value) {
      case NotificationTypeEnum.Push:
        return 'Пуш';
      case NotificationTypeEnum.Both:
        return 'Email и пуш';
      case NotificationTypeEnum.Email:
        return 'Email';
    }
    return '';
});

Vue.filter('ToUsersEnum', function(value: ToUsersEnum): string {  
    if (value == null) {
      return '';
    }
    switch(value) {
      case ToUsersEnum.All:
        return 'Все';
      case ToUsersEnum.FreeTariff:
        return 'На бесплатном тарифе';
    }
    return '';
});

Vue.filter('DocumentTypeEnum', function(value: DocumentTypeEnum): string {  
    if (value == null) {
      return '';
    }
    switch(value) {
      case DocumentTypeEnum.PrivacyPolicy:
        return 'Политика конфиденциальности';
    }
    return '';
});
